<script setup lang="ts">
import type { ShipexkursTab } from '~~/types'

defineProps({
  tabs: {
    type: Array as () => ShipexkursTab[],
    default: () => [],
  },
  style: {
    type: String as () => 'default' | 'ams',
    default: () => 'default',
  },
  hideHeader: {
    type: Boolean,
    default: false,
  },
});

const activeTab = ref('0');
</script>
<template>
  <!-- <div class="space-y-4"> -->
    <UCard variant="outline" class="bg-bunker-950 ring-0" :class="!hideHeader ? 'border border-default' : ''" :ui="{body: 'py-2 sm:py-2 sm:px-0 px-0'}">
      <template #default>
        <div>
          <template v-if="tabs.length < 2">
            <div v-if="!hideHeader" class="flex items-center space-x-2 border-b border-default pt-0 pb-2">
              <UIcon v-if="tabs[0]?.icon != 'chip'" :name="tabs[0]?.icon" class="size-5 ml-3" />
              <UChip v-else standalone inset class="animate-pulse shadow-[0_0px_20px_#00ffe8] ml-3" />
              <span class="text-sm text-primary font-medium">{{ tabs[0]?.label }}</span>
            </div>
          </template>
          <UTabs
            v-else
            v-model="activeTab"
            :items="tabs.map((tab) => ({ label: tab.label, icon: tab.icon }))"
            variant="link"
            class="w-full"
            :ui="{ list: 'pt-0', trigger: 'pt-px flex items-center group/trigger', leadingIcon: 'group-data-[state=active]/trigger:text-white'  }"
          />

          <div class="py-2 px-4">
             <slot name="tab-body" :tab="tabs[Number(activeTab)]" :index="Number(activeTab)">
               <ShipexkursShipTableTabContent :data="tabs[Number(activeTab)]?.items" />
             </slot>
             <slot
               name="tab-footer"
               :tab="tabs[Number(activeTab)]"
               :index="Number(activeTab)"
             />
          </div>
        </div>
      </template>
      <!-- <template #header>
        <div class="flex items-center">
          <UChip standalone inset class="animate-pulse shadow-[0_0px_20px_#00ffe8]" />
          <span class="ml-2 text-sm font-bold uppercase">Basis</span>
          <span class="ml-auto text-xs"><UBadge size="sm" color="neutral" variant="subtle" label="Klein" /></span>
        </div>
      </template>
      <template #description>
        <div class="p-2 border border-default rounded-lg grid grid-cols-3">
          test
        </div>
      </template> -->
    </UCard>
  <!-- </div> -->
</template>
